import PropTypes from "prop-types";
import {createRef} from "react";
import TinyMceEditor from "../../../../lib/components/wysiwyg/tinyMce/TinyMceEditor";
import InputBase from "./InputBase";

class InputWysiwyg extends InputBase {

  constructor(props) {
    super(props);
    this.wysiwygElementRef = createRef();
  }

  getValue() {
    return this.wysiwygElementRef.current.getValue();
  }

  render() {
    return <div className='relative border rounded'>
      <label className='ml-2.5 px-1 text-xs absolute z-50 -top-2.5 text-cn-color-white-960 bg-cn-color-black'>{this.props.labelElement}</label>
      <TinyMceEditor ref={this.wysiwygElementRef} defaultValue={this.props.defaultValue} variablesItems={this.props.variablesItems}
                     onChange={(e, value) => this.fireOnChange(e, value)} disabled={this.props.disabled}/>
    </div>
  }
}

InputWysiwyg.propTypes = {
  className: PropTypes.string,
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  variablesItems: PropTypes.array,
  disabled: PropTypes.bool
}
export default InputWysiwyg;
